/** Pedidos excluídos — para restaurar o que foi apagado por engano. */
import { createResource, For, Show } from 'solid-js'
import { Button } from '@ui/components/Button'
import { Dialog } from '@ui/components/Dialog'
import { api, versaoDados } from '../../nucleo/cliente'
import { moeda } from './formato'

const quandoBR = (q: string) => {
  const [d, h] = q.split(' ')
  return `${d.split('-').reverse().join('/')} ${h?.slice(0, 5) ?? ''}`
}

export function Excluidos(props: { aberto: boolean; podeEditar: boolean; aoFechar: () => void; aoRestaurar: (historicoId: number) => void }) {
  const [lista] = createResource(
    () => (props.aberto ? { v: versaoDados() } : false),
    () => api.pedidos.excluidos(),
  )
  return (
    <Dialog open={props.aberto} onOpenChange={(o) => !o && props.aoFechar()} class="w-[min(720px,calc(100vw-32px))]">
      <div class="p-6 flex flex-col gap-4 max-h-[85dvh]">
        <div>
          <h2 class="text-lg font-semibold text-ink">Pedidos excluídos</h2>
          <p class="text-xs text-ink-subtle">Restaurar volta o pedido com os mesmos dados, itens, cor e posição na grade.</p>
        </div>
        <Show when={(lista.latest ?? []).length > 0} fallback={<p class="text-sm text-ink-placeholder">{lista.loading ? 'Carregando…' : 'Nenhum pedido excluído.'}</p>}>
          <div class="overflow-auto rounded-lg border border-edge">
            <table class="w-full text-sm">
              <thead class="text-left text-ink-subtle border-b border-edge">
                <tr>
                  <th class="font-medium px-3 py-2">Excluído em</th>
                  <th class="font-medium px-3 py-2">Cliente</th>
                  <th class="font-medium px-3 py-2">Pedido</th>
                  <th class="font-medium px-3 py-2 text-right">Valor</th>
                  <th class="px-3 py-2" />
                </tr>
              </thead>
              <tbody>
                <For each={lista.latest}>
                  {(e) => (
                    <tr class="border-b border-edge-muted last:border-0">
                      <td class="px-3 py-2 text-ink-muted whitespace-nowrap">
                        {quandoBR(e.quando)}
                        <Show when={e.usuario}>
                          <div class="text-xs text-ink-subtle">{e.usuario}</div>
                        </Show>
                      </td>
                      <td class="px-3 py-2 text-ink">
                        {e.cliente ?? '—'} <span class="text-xs text-ink-subtle">· {e.ano}</span>
                      </td>
                      <td class="px-3 py-2 text-ink-muted">{e.pedido ?? '—'}</td>
                      <td class="px-3 py-2 text-right tabular-nums text-ink">{moeda(e.valor)}</td>
                      <td class="px-3 py-2 text-right">
                        <Show when={props.podeEditar}>
                          <Button size="sm" variant="secondary" onClick={() => (props.aoRestaurar(e.historicoId), props.aoFechar())}>
                            Restaurar
                          </Button>
                        </Show>
                      </td>
                    </tr>
                  )}
                </For>
              </tbody>
            </table>
          </div>
        </Show>
        <div class="flex justify-end">
          <Button variant="ghost" onClick={() => props.aoFechar()}>
            Fechar
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
